<div
  #line
  class="line pl-0 md:pl-[15px] md:h-[45px] flex items-center relative bg-white shadow-mobile md:shadow-none mb-3 md:mb-0 rounded-[5px] text-black overflow-hidden"
  [ngClass]="{
    'context-menu-open': hasContextMenuOpen,
    'drop-before': dropBefore,
    new: new
  }"
  [rkDndDraggable]="playlist"
  [rkDndDropzone]="['program']"
  dndEffectAllowed="copy"
  [dndType]="'program'"
  (dndDrop)="dropped($event)"
  [dndDragImageOffsetFunction]="dndDragImageOffsetFunction"
  [style.margin-left.px]="$xAxis()"
>
  <div class="name ellipsis">
    <div class="ellipsis flex items-center">
      <span class="move hidden md:inline"
        ><mat-icon fontIcon="fa-bars" fontSet="fa"></mat-icon
      ></span>
      <div
        class="inline-flex items-center justify-center mr-2 md:hidden h-15 aspect-square rounded-l"
        [style.background-color]="squareBGStyle(playlist.color)"
      >
        <mat-icon
          class="square-icon rounded-full border-2 border-brand"
          [style]="squareIconStyle(playlist.color)"
          fontSet="fa"
          [fontIcon]="playlist.sorting !== 'Sequential' ? 'fa-random' : 'fa-list'"
        ></mat-icon>
      </div>
      <rk-playlist-icon class="hidden md:inline" [playlist]="playlist"></rk-playlist-icon>
      <div class="flex flex-col min-w-0">
        <span class="ellipsis font-bold md:font-semibold">{{
          playlist.playlistName
        }}</span>
        <div class="block md:hidden text-gray-darkest">
          {{ 'MEDIA.PLAYLIST.NB_TRACKS' | translate: { tracks: playlist.tracksNumber } }}
        </div>
      </div>
    </div>
    <div class="name-buttons hidden">
      <rk-icon-button
        [bordered]="true"
        [svgIcon]="'dot-down'"
        [size]="23"
        [style]="{ width: '29px', height: '29px' }"
        (click)="onContextMenu($event)"
      >
      </rk-icon-button>
    </div>
  </div>
  <div class="type" *ngIf="playlist.sorting === 'Sequential'; else typeRandom">
    <mat-icon fontSet="fa" fontIcon="fa-list"></mat-icon>
    <span translate>SCHEDULE.PROGRAM.PLAYLIST_SEQUENTIAL</span>
  </div>
  <ng-template #typeRandom>
    <div class="type" translate>
      <mat-icon fontSet="fa" fontIcon="fa-random"></mat-icon>
      <span translate>SCHEDULE.PROGRAM.PLAYLIST_RANDOM</span>
    </div>
  </ng-template>
  <div class="tracks-played hidden md:block">
    <span class="tracks-number">{{ newNumber.value }}</span>
    <span class="edit-tracks-number">
      <rk-form-field>
        <input
          rkInput
          type="number"
          [inputType]="'num'"
          [value]="playlist.tracksNumber"
          [disabled]="isSaving$ | async"
          min="1"
          max="10000"
          (change)="changeTracksNumber($event)"
        />
      </rk-form-field>
    </span>
  </div>
  <div class="estimation">
    {{ playlist.playlistEstimatedDuration | bigTimeFormatLetters }}
  </div>
  <div rkDragImageRef class="drag-style">
    {{ playlist.playlistName }}
  </div>
  <div
    class="md:hidden mob-actions w-30 h-15 flex justify-center items-center overflow-hidden ml-3 rounded-r"
    [style.margin-right.px]="-$xAxis() - iconSize * 2"
  >
    <div
      class="bg-brand-light w-15 h-15 flex justify-center items-center overflow-hidden"
      (click)="startEditPlaylist()"
    >
      <mat-icon fontSet="fa" fontIcon="fa-pen" class="text-brand"></mat-icon>
    </div>
    <div
      class="bg-error w-15 h-15 flex justify-center items-center overflow-hidden"
      (click)="deletePlaylist()"
    >
      <mat-icon fontSet="far" fontIcon="fa-trash-alt" class="text-white"></mat-icon>
    </div>
  </div>
</div>

<context-menu
  #ctxMenu
  (open)="onOpenContextMenu()"
  (close)="onCloseContextMenu()"
  [menuClass]="'ctx-program'"
>
  <ng-template contextMenuItem (execute)="startEditPlaylist()">
    <mat-icon fontSet="fa" fontIcon="fa-pen"></mat-icon>
    <span translate>MEDIA.CONTEXT_MENU.EDIT</span>
  </ng-template>
  <ng-template contextMenuItem (execute)="duplicatePlaylist('after')">
    <mat-icon fontSet="fa" fontIcon="fa-clone"></mat-icon>
    <span translate>MEDIA.CONTEXT_MENU.DUPLICATE_PROGRAM_PLAYLIST</span>
  </ng-template>
  <ng-template contextMenuItem (execute)="addPlaylist('after')">
    <mat-icon fontSet="fa" fontIcon="fa-plus"></mat-icon>
    <span translate>MEDIA.CONTEXT_MENU.ADD_PROGRAM_PLAYLIST</span>
  </ng-template>
  <ng-template contextMenuItem [divider]="true"></ng-template>
  <ng-template contextMenuItem (execute)="deletePlaylist()">
    <mat-icon fontSet="fa" fontIcon="fa-trash"></mat-icon>
    <span translate>MEDIA.CONTEXT_MENU.DELETE</span>
  </ng-template>
</context-menu>
